/** Operator-facing label for `metadata.ai_pause.by` (inbox badge + paused banner). */
export function pauseOriginLabel(by: string | null | undefined): string {
  switch (by) {
    case 'ai_handover':
      return 'Escalation'
    case 'operator_echo':
      return 'Operator reply'
    case 'crm_operator_reply':
      return 'CRM operator'
    case 'contact_exclusion':
      return 'Excluded contact'
    case 'user':
      return 'Manual'
    default:
      // Unknown origin or legacy rows without ai_pause metadata
      return 'Paused'
  }
}
